import { connect } from 'react-redux';
import {
  getPayments,
  getPaymentsTotal,
} from '../../../register/payment/reducer/payments/selectors';
import { getAdjustments, getTips, getTotalTips } from '../../../register/tipping/selectors';
import PaymentSummary from '../components/PaymentSummary';

const PaymentSummaryContainer = connect(
  (state) => {
    const totalTips = getTotalTips(state);
    return {
      totalTips,
      paymentMethods: getPayments(state),
      tips: getTips(state),
      total: getPaymentsTotal(state) + totalTips,
      adjustments: getAdjustments(state),
    };
  }
)(PaymentSummary);

export default PaymentSummaryContainer;
